import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { DekorPage } from '../dekor/dekor';
import { QuickviewPage } from '../quickview/quickview';


@Component({
  selector: 'page-masse',
  templateUrl: 'masse.html',
})
export class MassePage {
productname: string;
producttype: string; 
windowtype: string;
typeopen: string
windowlong: number;
windowwide: number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public popoverCtrl: PopoverController) {
  
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen); 
  
  }
 
  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
        presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen}
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
    ionViewWillEnter() : void
   {
    this.getProductTypes();
   }
    
    clickmasse() {
    if (this.windowlong < 850 || this.windowlong > 3000) {
            this.alertCtrl.create({
            title: 'Gesamtlänge ungültig',
            message: 'Die Gesamtlänge weicht vom zulässigen Bereich ab. Bitte Eingabe überprüfen.',
            buttons: ['OK']
          }).present();
          return;
    } 
    if (this.windowwide < 480 || this.windowlong > 1700) {
            this.alertCtrl.create({
            title: 'Gesamtbreite ungültig',
            message: 'Die Gesamtbreite weicht vom zulässigen Bereich ab. Bitte Eingabe überprüfen.',
            buttons: ['OK']
          }).present();
          return;
    }   
    else {
    this.navCtrl.push(DekorPage, {
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide
    });
  }
  }
   
   
     getProductTypes(){
  this.presentLoading();
  this.userService.getProductTypes2().subscribe((data : any) =>
      {
          this.types2 = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getProductTypes();
   refresher.complete();
   }

}



// WEBPACK FOOTER //
// ./src/pages/masse/masse.ts